import { ICellRendererParams } from "ag-grid-community";
import clsx from "clsx";
import React, { useId } from "react";
import { Tooltip } from "react-tooltip";

export type TCellWithBackgroundRenderer = {
  className?: string;
  color: string;
  background: string;
  icon?: React.ReactElement;
  onClick?: () => void;
  tooltip?: string;
};

const CellWithBackgroundRenderer: React.FC<{
  params: ICellRendererParams;
  custom: TCellWithBackgroundRenderer;
}> = ({
  params,
  custom: { className, color, background, icon, onClick, tooltip },
}) => {
  const tooltipId = useId();

  return (
    <div
      className={clsx([
        "inline",
        "whitespace-nowrap",
        "rounded-full md:rounded-full",
        "gap-1",
        "px-2",
        "py-1",
        "shrink-0",
        {
          "cursor-pointer": !!onClick,
        },
      ])}
      style={{ color, background }}
      onClick={() => onClick?.()}
      data-tooltip-id={tooltipId}
      data-tooltip-content={tooltip}
      data-tooltip-position-strategy="fixed"
      data-tooltip-offset={0}
    >
      {icon && icon}
      {params?.value}
      <Tooltip id={tooltipId} style={{ zIndex: 99 }} />
    </div>
  );
};

export default React.memo(CellWithBackgroundRenderer);
